import React from 'react';
import { Link } from 'react-router-dom';

import { serverIP, options } from '../config';
import TFAIHomeLogo from '../assets/images/TFAI-logo-w.svg'

const Footer = () => {
    const chunkedOptions = options.reduce((chunks, item, i) => {
        if (i % 3 === 0) {
            chunks.push([item]);
        } else {
            chunks[chunks.length - 1].push(item);
        }
        return chunks;
    }, []);

    return (
    <footer>
        <div className="row g-0">
            <div className="col-12 col-sm-7 col-lg-9">
                <div className="site-map row g-0">
                    <div className="col-4 col-sm-3 col-lg-2">
                        <Link to="/guide">網站說明</Link>
                        <a href="https://www.tfai.org.tw/downloads/rent">電影租借</a>
                        <a href={serverIP+'/media/download/1955_1981_TaiwaneseCinema.pdf'} target={"_blank"} rel="noreferrer">台語片資料</a>
                    </div>
                    <div className="col-auto">
                        <a className="a-disabled">中心藏品</a>
                        <ul>
                            <div className="row subLinks">
                                {chunkedOptions.map((chunk, index) => {
                                    return (
                                        <div className="col-auto" key={index}>
                                            {chunk.map((option, i) => (
                                                <li key={i}>
                                                    <Link to={`/collection?keyWord=&advanceSearch=[]&selectedOptions=[{"value":"${option.value}","label":"${option.label}"}]&startDate=&endDate=&page=1`} >
                                                        - {option.label}
                                                    </Link>
                                                </li>
                                            ))}
                                        </div>
                                    )
                                })}
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-12 col-sm-auto footer-i">
                <a href="https://www.tfai.org.tw"><img alt="home" src={TFAIHomeLogo} width={60} height={60}/></a>
                <span style={{marginTop: 0}}>
                    電話：(02)8522-8000<br/>
                    傳真：(02)8522-2656<br/>
                    地址：242030新北市新莊區文藝路2號<br/>
                    國家電影及視聽文化中心版權所有
                </span>
            </div>
        </div>
    </footer>
    )
};

export default Footer;
